define('cookieutil',['require'],function (require) {
    'use strict';
    var CookieUtil = {
        /**
         * Determines if the user/browser is allowing cookies by setting an arbitrary cookie and attempting to retrieve its value
         * @returns {bool} 
         */
        supportingCookies: function() {
            CookieUtil.set('testCookie', 'yep', CookieUtil.expireDate(1));
            if (CookieUtil.get('testCookie') === 'yep') {
                CookieUtil.unset('testCookie');
                return true;
            } else {
                return false;
            }
        },

        /**
         * Get the value of the given cookie or return null if it doesn't exist
         * @param {string} name 
         * @returns {string OR null} 
         */
        get: function(name) {
            var cookieName = encodeURIComponent(name) + '=',
                cookieStart = document.cookie.indexOf(cookieName),
                cookieValue = null;

            if (cookieStart > -1) {
                var cookieEnd = document.cookie.indexOf(';', cookieStart);
                if (cookieEnd === -1) {
                    cookieEnd = document.cookie.length;
                }
                cookieValue = decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, cookieEnd));
            }

            return cookieValue;
        },

        /**
         * Creates/Updates a cookie value.
         * @param {string} name 
         * @param {string} value 
         * @param {date} expires 
         * @param {string} path 
         * @param {string} domain 
         * @param {bool} secure  
         */
        set: function(name, value, expires, path, domain, secure) {
            var cookieText = encodeURIComponent(name) + '=' +
                encodeURIComponent(value);

            if (expires instanceof Date) {
                cookieText += '; expires=' + expires.toGMTString();
            }
            if (path) {
                cookieText += '; path=' + path;
            }
            if (domain) {
                cookieText += '; domain=' + domain;
            }
            if (secure) {
                cookieText += '; secure';
            }
            document.cookie = cookieText;
        },

        /**
         * Since you can't technically delete a cookie, use this to set its expire date in the past to effectively delete it
         * @param {string} name 
         * @param {string} path 
         * @param {string} domain 
         * @param {bool} secure  
         */
        unset: function(name, path, domain, secure) {
            this.set(name, '', new Date(0), path, domain, secure);
        },

        /**
         * get a date in the future
         * @param {int} days 
         * @returns {date} 
         */
        expireDate: function(days) {
            var eDate = new Date();
            eDate.setDate(eDate.getDate() + days);
            return eDate;
        }
    };
    return CookieUtil;
});

